module.exports = __webpack_public_path__ + "img/11. кабинет массажа.0a387903.jpg";